// You can write more code here

/* START OF COMPILED CODE */

import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor1 from '@/game/prefabs/World/Mentors/Mentor1';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from './TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level4 extends TilemapScene {
  constructor() {
    super('Level4');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // forest_biome_4
    const forest_biome_4 = this.add.tilemap('forest-biome-4');
    forest_biome_4.addTilesetImage('summer forest', 'summer forest');
    forest_biome_4.addTilesetImage('summer 32x32', 'summer 32x32');
    forest_biome_4.addTilesetImage(
      'summer trees 80x112',
      'summer trees 80x112',
    );
    forest_biome_4.addTilesetImage('collision', 'collision & alpha');

    // terrain___summer_forest_1
    forest_biome_4.createLayer(
      'Terrain - summer forest',
      ['summer forest'],
      0,
      0,
    );

    // cliff_shadows___summer_forest_1
    forest_biome_4.createLayer(
      'Cliff shadows - summer forest',
      ['summer forest'],
      0,
      0,
    );

    // cliffs___summer_forest_1
    forest_biome_4.createLayer(
      'Cliffs - summer forest',
      ['summer forest'],
      0,
      0,
    );

    // objects___summer_forest
    forest_biome_4.createLayer(
      'objects - summer forest',
      ['summer forest', 'summer 32x32'],
      0,
      0,
    );

    // tOP_cliff_shadows___summer_forest_1
    forest_biome_4.createLayer(
      'TOP cliff shadows - summer forest',
      ['summer forest'],
      0,
      0,
    );

    // tOP_cliffs_and_foliage___summer_forest_1
    forest_biome_4.createLayer(
      'TOP cliffs and foliage - summer forest',
      ['summer forest', 'summer trees 80x112'],
      0,
      0,
    );

    // tOP_on_cliff_deco___summer_forest_1
    forest_biome_4.createLayer(
      'TOP on-cliff deco - summer forest',
      ['summer forest'],
      0,
      0,
    );

    // cOLLISION_1
    const cOLLISION_1 = forest_biome_4.createLayer(
      'COLLISION',
      ['collision'],
      0,
      0,
    )!;
    cOLLISION_1.visible = false;

    // player
    const player = new Player(this, 605, 53);
    this.add.existing(player);

    // worldNode
    const worldNode = new WorldNode(this, 646, 144);
    this.add.existing(worldNode);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 591, 313);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 696, 400);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 437, 135);
    this.add.existing(worldNode_3);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 328, 191);
    this.add.existing(worldNode_4);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 92, 218);
    this.add.existing(worldNode_5);

    // portal
    const portal = new Portal(this, 39, 330);
    this.add.existing(portal);

    // forestTree1
    const forestTree1 = new ForestTree1(this, 560, 32);
    this.add.existing(forestTree1);

    // forestTree
    const forestTree = new ForestTree1(this, 464, 64);
    this.add.existing(forestTree);

    // forestTree_1
    const forestTree_1 = new ForestTree1(this, 304, 16);
    this.add.existing(forestTree_1);

    // forestTree_2
    const forestTree_2 = new ForestTree1(this, 240, 48);
    this.add.existing(forestTree_2);

    // forestTree_3
    const forestTree_3 = new ForestTree1(this, 160, 64);
    this.add.existing(forestTree_3);

    // forestTree_4
    const forestTree_4 = new ForestTree1(this, 80, 80);
    this.add.existing(forestTree_4);

    // forestTree_5
    const forestTree_5 = new ForestTree1(this, 736, 112);
    this.add.existing(forestTree_5);

    // forestTree_6
    const forestTree_6 = new ForestTree1(
      this,
      704,
      80,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_6);

    // forestTree_7
    const forestTree_7 = new ForestTree1(
      this,
      640,
      32,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_7);

    // forestTree_8
    const forestTree_8 = new ForestTree1(
      this,
      528,
      48,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_8);

    // forestTree_9
    const forestTree_9 = new ForestTree1(
      this,
      384,
      64,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_9);

    // forestTree_10
    const forestTree_10 = new ForestTree1(
      this,
      128,
      32,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_10);

    // forestTree_11
    const forestTree_11 = new ForestTree1(this, 0, 96, 'summer_trees_sheet', 0);
    this.add.existing(forestTree_11);

    // forestTree_12
    const forestTree_12 = new ForestTree1(
      this,
      208,
      80,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_12);

    // forestTree_13
    const forestTree_13 = new ForestTree1(
      this,
      288,
      96,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_13);

    // forestTree_14
    const forestTree_14 = new ForestTree1(
      this,
      336,
      64,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_14);

    // forestTree_15
    const forestTree_15 = new ForestTree1(
      this,
      416,
      112,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_15);

    // forestTree_16
    const forestTree_16 = new ForestTree1(
      this,
      352,
      128,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_16);

    // forestTree_17
    const forestTree_17 = new ForestTree1(
      this,
      720,
      272,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_17);

    // forestTree_18
    const forestTree_18 = new ForestTree1(
      this,
      752,
      32,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_18);

    // forestTree_19
    const forestTree_19 = new ForestTree1(this, 576, 160, 'summer 32x', 0);
    this.add.existing(forestTree_19);

    // forestTree_20
    const forestTree_20 = new ForestTree1(this, 288, 144, 'summer 32x', 0);
    this.add.existing(forestTree_20);

    // forestTree_21
    const forestTree_21 = new ForestTree1(this, 192, 224, 'summer 32x', 0);
    this.add.existing(forestTree_21);

    // forestTree_22
    const forestTree_22 = new ForestTree1(this, 752, 288, 'summer 32x', 0);
    this.add.existing(forestTree_22);

    // forestTree_23
    const forestTree_23 = new ForestTree1(this, 736, 240, 'summer 32x', 0);
    this.add.existing(forestTree_23);

    // forestTree_24
    const forestTree_24 = new ForestTree1(this, 448, 320, 'summer 32x', 2);
    this.add.existing(forestTree_24);

    // forestTree_25
    const forestTree_25 = new ForestTree1(this, 368, 208, 'summer 32x', 2);
    this.add.existing(forestTree_25);

    // forestTree_26
    const forestTree_26 = new ForestTree1(
      this,
      568,
      144,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_26);

    // forestTree_27
    const forestTree_27 = new ForestTree1(
      this,
      728,
      496,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_27);

    // forestTree_28
    const forestTree_28 = new ForestTree1(
      this,
      88,
      192,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_28);

    // forestTree_29
    const forestTree_29 = new ForestTree1(
      this,
      40,
      160,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_29);

    // forestTree_30
    const forestTree_30 = new ForestTree1(
      this,
      24,
      272,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_30);

    // mentor
    const mentor = new Mentor1(this, 640, 72);
    this.add.existing(mentor);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 88, 304);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 304, 304);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 472, 360);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 568, 184);
    this.add.existing(worldNode_9);

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 3;
    worldNode.NPCId = 5;

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 3;
    worldNode_1.NPCId = 4;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 3;
    worldNode_2.NPCId = 3;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 3;
    worldNode_3.NPCId = 2;

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 3;
    worldNode_4.NPCId = 1;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 3;
    worldNode_5.NPCId = 0;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 3;
    worldNode_6.NPCId = 0;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 3;
    worldNode_7.NPCId = 0;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 3;
    worldNode_8.NPCId = 0;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 3;
    worldNode_9.NPCId = 0;

    this.player = player;
    this.portal = portal;
    this.mentor = mentor;
    this.forest_biome_4 = forest_biome_4;

    this.events.emit('scene-awake');
  }

  private player!: Player;
  private portal!: Portal;
  private mentor!: Mentor1;
  private forest_biome_4!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.forest_biome_4,
      portal: this.portal,
      mentor: this.mentor,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
